import { useState, useEffect } from "react";
import { Chakra, CookiesNotice } from "@airhelp/react-ui-components";
import { useCookies } from "react-cookie";
import { useLanguage, useTranslations } from "contexts/LocalizationContext/hooks";
import { COOKIES_NOTICE_COOKIE_NAME, COOKIES_NOTICE_COOKIE_EXPIRATION } from "config/cookies";
import { extractDomain, getExpDateByDays } from "utils/cookiesUtils";
import getPageUrl from "utils/getPageUrl";

const { useBreakpointValue } = Chakra;

const CookiesNoticeAdapter = () => {
  const translations = useTranslations();
  const language = useLanguage();
  const [cookies, setCookie] = useCookies([COOKIES_NOTICE_COOKIE_NAME]);
  const [isCookieAccepted, setCookieAccepted] = useState(true);
  const [domain, setDomain] = useState(null);
  const cookieTextTranslationKey =
    useBreakpointValue({ base: "cookies_notice_short", md: "cookies_notice" }) || "cookies_notice_short";

  const cookiesTranslationVariables = {
    "%cookie-link-attrs%": `href="${getPageUrl(
      language,
      "cookies"
    )}" target="_blank" rel="noopener noreferrer" title=${translations("cookies")}`,
  };

  useEffect(() => {
    if (!cookies[COOKIES_NOTICE_COOKIE_NAME]) setCookieAccepted(false);
  }, [cookies]);

  useEffect(() => {
    setDomain(extractDomain());
  }, []);

  const acceptCookiesHandler = () => {
    setCookie(COOKIES_NOTICE_COOKIE_NAME, "true", {
      domain,
      path: "/",
      expires: getExpDateByDays(COOKIES_NOTICE_COOKIE_EXPIRATION),
    });

    setCookieAccepted(true);
  };

  return (
    <CookiesNotice
      hideNotice={isCookieAccepted}
      buttonText={translations("cookies_got_it")}
      htmlText={translations(cookieTextTranslationKey, cookiesTranslationVariables)}
      onClick={acceptCookiesHandler}
    />
  );
};

export default CookiesNoticeAdapter;
